export default __webpack_public_path__ + "static/media/closeIcon.21b88c6c.svg";